import Player from "xgplayer";
import $ from "jquery"

function createDom(el = 'div', tpl = '', attrs = {}, cname = '') {
    let dom = document.createElement(el)
    dom.className = cname
    dom.innerHTML = tpl
    Object.keys(attrs).forEach(item => {
        let key = item
        let value = attrs[item]
        if (el === 'video' || el === 'audio') {
            if (value) {
                dom.setAttribute(key, value)
            }
        } else {
            dom.setAttribute(key, value)
        }
    })
    return dom
}

const htmlVirtual = []
export const customPageTurning = function (player, options, handle) {
    if (options.controls === false) return;
    const btn = createDom('xg-right-grid',
        `<div class="custom-page-turning-container" style="position: relative;bottom: -5px"><span style="margin-right: 16px;padding: 3px 10px;border: 1px solid #ffffffd9;" class="custom-page-turning">上一页</span><span  style="padding: 3px 10px;border: 1px solid #ffffffd9;" class="custom-page-turning">下一页</span></div>`,
        {}, 'xg-right-grid');
    $(player.controls.innerRoot).find('.xg-center-grid').last().before(btn)
    const list = ['click', 'touchend']
    list.forEach((item) => {
        btn.addEventListener(item, function (e) {
            e.preventDefault()
            e.stopPropagation()
            if ($(e.target).text() === '下一页') {
                handle.playNext && handle.playNext()
            }
            if ($(e.target).text() === '上一页') {
                handle.playPrev && handle.playPrev()
            }
        })
    })
}
